import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerAdjuntoComponent } from './ver-adjunto.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SharedPipesModule } from '@shared/pipes/shared-pipes.module';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [
    VerAdjuntoComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    SharedPipesModule,
    MatButtonModule
  ],
  exports: [
    VerAdjuntoComponent
  ]
})
export class VerAdjuntoModule { }
